import React, { useEffect, useState } from "react";
import axiosClient from "../../../api/axiosClient";
import "./SeoContentPage.css";

/* ------------------------------------------------------------------ */
/*  NOTE FOR BACKEND: mirrors the same pattern as Gallery — add        */
/*    GET  /api/v1/seo/home/   -> current SEO fields for the homepage  */
/*    PUT  /api/v1/seo/home/   -> save edits                           */
/*  You can extend the PAGES list below once you have more pages      */
/*  (e.g. /categories, /about) that each need their own SEO record.   */
/* ------------------------------------------------------------------ */
const SEO_ENDPOINT = "/api/v1/seo/";

const EMPTY_FORM = {
  meta_title: "",
  meta_description: "",
  keywords: "",
  og_title: "",
  og_description: "",
};

export default function SeoContentPage() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axiosClient.get(SEO_ENDPOINT);
        if (!cancelled && data?.data) {
          setForm({ ...EMPTY_FORM, ...data.data });
        }
      } catch (err) {
        if (!cancelled) {
          setErrorMsg(
            err?.response?.status === 404
              ? "SEO API isn't wired up on the backend yet — ask your dev to add the /api/v1/seo/ endpoint."
              : err?.response?.data?.message || "Couldn't load SEO content."
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  function updateField(key, value) {
    setForm((f) => ({ ...f, [key]: value }));
    setSaved(false);
  }

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setErrorMsg("");
    try {
      await axiosClient.put(SEO_ENDPOINT, form);
      setSaved(true);
    } catch (err) {
      setErrorMsg(err?.response?.data?.message || "Couldn't save SEO content.");
    } finally {
      setSaving(false);
    }
  }

  const titleLen = form.meta_title.length;
  const descLen = form.meta_description.length;

  return (
    <div className="spage">
      <div className="spage__head">
        <p className="spage__eyebrow">Search Presence</p>
        <h1 className="spage__title">SEO Content</h1>
        <p className="spage__sub">Controls how the homepage appears on Google &amp; when shared as a link.</p>
      </div>

      {errorMsg && <div className="spage__banner">{errorMsg}</div>}

      {loading ? (
        <p className="spage__state">Loading…</p>
      ) : (
        <form className="spage__form" onSubmit={handleSave}>
          <section className="spage__section">
            <h3>Search result</h3>
            <label className="spage__field">
              <span>Meta title <em className={titleLen > 60 ? "spage__over" : ""}>{titleLen}/60</em></span>
              <input value={form.meta_title} onChange={(e) => updateField("meta_title", e.target.value)} disabled={saving} />
            </label>
            <label className="spage__field">
              <span>Meta description <em className={descLen > 160 ? "spage__over" : ""}>{descLen}/160</em></span>
              <textarea rows={3} value={form.meta_description} onChange={(e) => updateField("meta_description", e.target.value)} disabled={saving} />
            </label>
            <label className="spage__field">
              <span>Keywords <small>(comma separated)</small></span>
              <input value={form.keywords} onChange={(e) => updateField("keywords", e.target.value)} disabled={saving} />
            </label>
          </section>

          <section className="spage__section">
            <h3>Link preview (WhatsApp / Facebook)</h3>
            <label className="spage__field">
              <span>Share title</span>
              <input value={form.og_title} onChange={(e) => updateField("og_title", e.target.value)} disabled={saving} />
            </label>
            <label className="spage__field">
              <span>Share description</span>
              <textarea rows={2} value={form.og_description} onChange={(e) => updateField("og_description", e.target.value)} disabled={saving} />
            </label>
          </section>

          <div className="spage__preview">
            <p className="spage__preview-url">vpfitness.in</p>
            <p className="spage__preview-title">{form.meta_title || "Meta title goes here"}</p>
            <p className="spage__preview-desc">{form.meta_description || "Meta description goes here."}</p>
          </div>

          <div className="spage__actions">
            {saved && <span className="spage__saved">Saved ✓</span>}
            <button type="submit" className="spage__save-btn" disabled={saving}>
              {saving ? "Saving…" : "Save changes"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
